import { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import _ from 'lodash';

import './styles.scss';

import Header from 'components/organisms/header/index.jsx';
import Button from 'components/atoms/button';
import FormContent from 'components/organisms/formContent';
import FormActions from 'components/molecules/formActions';
import RadioButtonGroup from 'components/molecules/radioButtonGroup/index.jsx';
import RadioButton from 'components/atoms/radioButton/index.jsx';
import CollapsableSelectList from 'components/organisms/collapsableSelectList';
import CollapsableSelectListItem from 'components/molecules/collapsableSelectListItem';
import CollapsableSelectListItemHeader from 'components/atoms/collapsableSelectListItemHeader';
import CollapsableSelectListItemContent from 'components/atoms/collapsableSelectListItemContent';
import Modal from 'components/molecules/modal';
import WizardProgress from 'components/organisms/wizard/progress';
import Loader from 'components/atoms/loader';
import { currency } from 'helpers/format';
import { fetchServiceCategories } from 'actions/models';
import { request as fetchMaintenancePlans } from 'actions/maintenancePlans';
import { getVehicleAttributeIds } from 'helpers/vehicle';
import serviceHelper from 'helpers/service';
import validate from '../validate';

class ServiceSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    const vehicleAttributes = getVehicleAttributeIds(
      this.props.vehicle,
      this.props.engine,
      this.props.transmission,
      this.props.traction
    );

    this.props.fetchServiceCategories(vehicleAttributes, this.props.brandId);
    this.props.fetchMaintenancePlans(
      vehicleAttributes,
      this.props.license_plate,
      this.props.brandId
    );
  }

  hasServiceSelected(services) {
    return services && services.reduce(service => service != null, false);
  }

  /**
   * Return the help text for this category.
   * @param {Object} category
   */
  helpText(category) {
    let helpText = '';

    if (category.for_warranty && !category.not_for_warranty) {
      helpText += 'Solo vehículos en garantía. ';
    }

    if (category.require_confirmation) {
      helpText += 'Sujeto a disponibilidad. ';
    }

    return helpText;
  }

  getCategory(service) {
    return _.find(this.props.serviceCategories, { id: service.service_category_id });
  }

  render() {
    const {
      services,
      handleSubmit,
      previousPage,
      isFetching,
      serviceCategories,
      is_under_warranty,
      legacy_service,
      priceList,
    } = this.props;

    const { explainService } = this.state;

    const vehicleName = this.props.vehicle.name.toLowerCase();
    const partiallyBonified = !vehicleName.includes('vento') && !vehicleName.includes('tiguan');

    return (
      <div className="serviceSelect">
        {explainService && (
          <Modal open onClose={() => this.setState({ explainService: null })}>
            <h6>{this.getCategory(explainService).name}</h6>
            <h3>{explainService.name}</h3>

            {legacy_service !== true && <p>{explainService.description}</p>}

            {legacy_service && <p>{explainService.alternative_description}</p>}
          </Modal>
        )}

        <Header inFlow />
        <WizardProgress step="2" />
        <section className="stepContent">
          <div className="container">
            <div className="col">
              <h2>Selecciona los servicios</h2>
              <p className="m">Ofrecemos todo lo que necesite tu vehículo.</p>
              <FormContent nomargins>
                <form onSubmit={handleSubmit}>
                  <CollapsableSelectList>
                    {isFetching && <Loader />}

                    {serviceCategories.length === 0 && !isFetching && (
                      <div className="noServices">
                        <p className="m">
                          No hay ningún servicio disponible para el vehículo seleccionado.
                          <br />
                          Para consultas llamános al 0261 4439300.
                        </p>
                      </div>
                    )}

                    {!isFetching &&
                      is_under_warranty !== undefined &&
                      serviceCategories.map((category, i) => {
                        if (category.checked === undefined) {
                          category.checked = false;
                        }

                        if (
                          is_under_warranty == false &&
                          category.for_warranty &&
                          category.not_for_warranty == false
                        ) {
                          return;
                        }

                        if (
                          is_under_warranty == true &&
                          category.not_for_warranty &&
                          category.for_warranty == false
                        ) {
                          return;
                        }

                        return (
                          <CollapsableSelectListItem key={i}>
                            <CollapsableSelectListItemHeader
                              title={category.name}
                              name="categories"
                              helpText={this.helpText(category)}
                              onClick={() => {
                                category.checked = !category.checked;
                                this.setState(this.state);
                              }}
                              checked={category.checked}
                            />
                            <CollapsableSelectListItemContent checked={category.checked}>
                              <RadioButtonGroup list>
                                {category.model_services.map((service, j) => {
                                  const price = serviceHelper.price(service, {
                                    legacyService: legacy_service,
                                    brand: this.props.brand,
                                    vehicleName,
                                  });
                                  const type = serviceHelper.priceType(service, {
                                    legacyService: legacy_service,
                                    brand: this.props.brand,
                                  });

                                  if (!price && !service.bonified) {
                                    return null;
                                  }

                                  const contracted = this.serviceContractedByPlan(service);
                                  const bonified = service.bonified;

                                  return (
                                    <Field
                                      key={j}
                                      name="services"
                                      component={RadioButton}
                                      props={{
                                        fieldValue: service,
                                        group: 'service_category_id',
                                        link: 'Ver detalle',
                                        linkOnClick: () => {
                                          this.setState({ explainService: service });
                                        },
                                      }}
                                    >
                                      {service.name}

                                      {contracted && (
                                        <div className="price">
                                          Incluido en contrato de mantenimiento<sup>*</sup>
                                        </div>
                                      )}

                                      {bonified && !partiallyBonified && (
                                        <div className="price">
                                          Precio bonificado<sup>*</sup>
                                        </div>
                                      )}

                                      {!contracted && !bonified &&
                                        type === serviceHelper.priceTypes.PROMOTION && (
                                          <div className="pricePromotion">{currency(price)}</div>
                                        )}

                                      {!contracted && !bonified && type === serviceHelper.priceTypes.DEFAULT && (
                                        <div className="price">{currency(price)}</div>
                                      )}

                                      {!contracted && bonified && partiallyBonified && type === serviceHelper.priceTypes.DEFAULT && (
                                        <div className="price">{currency(price)}**</div>
                                      )}

                                      {!contracted && bonified && partiallyBonified && type === serviceHelper.priceTypes.PROMOTION && (
                                        <div className="price">{currency(price)}**</div>
                                      )}
                                    </Field>
                                  );
                                })}
                              </RadioButtonGroup>
                            </CollapsableSelectListItemContent>
                          </CollapsableSelectListItem>
                        );
                      })}
                      {priceList && (
                        <div className="priceList">
                          <p className="m">
                            Los precios indicados tienen validez hasta el día <strong>{priceList.date_to_print}</strong>.
                          </p>
                        </div>
                      )}
                  </CollapsableSelectList>
                  <FormActions back={previousPage}>
                    <Button
                      type="submit"
                      buttonText="Continuar"
                      style="blue"
                      disabled={!this.hasServiceSelected(services)}
                    />
                  </FormActions>
                </form>
              </FormContent>
              <br />* Sujeto a confirmación.
              <br />** Consultar bonificación de serie.
            </div>
          </div>
        </section>
      </div>
    );
  }

  serviceContractedByPlan(service) {
    const contractedPlan = this.props.maintenancePlanContracted;

    return (
      contractedPlan && Object.keys(contractedPlan.selectedServices).indexOf(`${service.id}`) >= 0
    );
  }
}

ServiceSelect = reduxForm({
  form: 'shiftRequest',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(ServiceSelect);

const selector = formValueSelector('shiftRequest');

ServiceSelect = connect(state => {
  return {
    vehicle: selector(state, 'vehicle'),
    engine: selector(state, 'engine'),
    transmission: selector(state, 'transmission'),
    traction: selector(state, 'traction'),
    services: selector(state, 'services'),
    is_under_warranty: selector(state, 'is_under_warranty'),
    legacy_service: selector(state, 'legacy_service'),
    license_plate: selector(state, 'license_plate'),
  };
})(ServiceSelect);

const mapStateToProps = state => {
  return {
    serviceCategories: state.models.serviceCategories,
    isFetching: state.models.isFetching,
    brandId: state.configuration.brand_id,
    maintenancePlanContracted: state.maintenancePlans.contracted,
    brand: state.configuration.brand,
    priceList: state.models.priceList,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchServiceCategories: (attributes, brandId) => {
      dispatch(fetchServiceCategories(attributes, brandId));
    },
    fetchMaintenancePlans: (vehicle, licensePlate, brandId) => {
      dispatch(fetchMaintenancePlans(vehicle, licensePlate, brandId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceSelect);
